import React, { FC } from 'react'
import { FacetListChips } from 'components/SA/SearchProvider'
import { DEFAULT_APP, FACET_NAMES, OTHER_FACETS } from '../../helpers/constants'

const commonFacets: ReadonlyArray<string> = Object.values(FACET_NAMES)
const otherFacets: ReadonlyArray<string> = Object.values(OTHER_FACETS)

const ARTWORK_SEARCH_FILTERS_WHITE_LIST: ReadonlyArray<string> = [
  ...commonFacets,
  ...otherFacets,
  'custom__geo_prices',
  'custom__print_all_prices',
]

type ArtworkSearchFiltersChipsProps = {
  customClearFilterCallback?: () => void
  baseUrl: string
}

const AllArtworksFiltersChips: FC<ArtworkSearchFiltersChipsProps> = ({
  customClearFilterCallback,
  baseUrl,
}) => {
  return (
    <FacetListChips
      baseUrl={baseUrl}
      nextAppRoute={DEFAULT_APP}
      filtersWhiteList={ARTWORK_SEARCH_FILTERS_WHITE_LIST}
      customClearFilterCallback={customClearFilterCallback}
    />
  )
}

export default AllArtworksFiltersChips
